<template>
  <div class="page">
    <PageHeader>
      Транзакции
    </PageHeader>

    <div class="sub_header">
      <el-row :gutter="20">
        <el-col :span="6" :offset="0">
          <el-input
            v-model="search"
            placeholder="Поиск по транзакциям"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="6" :offset="0">
          <el-select
            v-model="sort"
            placeholder="Сначала..."
            filterable
            @change="loadTransactionList()"
          >
            <el-option value="0" label="Новые"></el-option>
            <el-option value="1" label="Старые"></el-option>
            <el-option value="2" label="В ожидании средств"></el-option>
            <el-option value="3" label="Подтверждено"></el-option>
            <el-option value="4" label="Отклонено"></el-option>
            <el-option value="5" label="Отменено"></el-option>
            <el-option value="6" label="Возобновленные"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6" :offset="0">
          <el-select
            v-model="source"
            placeholder="Источник..."
            filterable
            @change="loadTransactionList()"
          >
            <el-option value="" label="Все"></el-option>
            <el-option value="catbit" label="CatBit"></el-option>
            <el-option value="stylebtc" label="StyleBTC"></el-option>
            <el-option value="api" label="Api"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6" :offset="0">
          <el-radio-group v-model="selectedComponent">
            <el-radio-button
              v-for="comp in transactionComponents"
              :key="comp.id"
              :label="comp.id"
              >{{ comp.title }}</el-radio-button
            >
          </el-radio-group>
        </el-col>
      </el-row>
      <el-popover placement="bottom" width="500" trigger="click">
        <div v-loading="csvLoading">
          <el-row :gutter="20">
            <el-col :span="24" :offset="0">
              <a href="#" @click.prevent="getCsv()">За все время</a>
              <a
                href="#"
                @click.prevent="
                  getCsv({
                    date: {
                      $gte: $dayjs().startOf('day')
                    }
                  })
                "
                >За сегодня</a
              >
              <a
                href="#"
                @click.prevent="
                  getCsv({
                    date: {
                      $gte: $dayjs().startOf('week')
                    }
                  })
                "
                >За эту неделю</a
              >
              <a
                href="#"
                @click.prevent="
                  getCsv({
                    date: {
                      $gte: $dayjs().startOf('month')
                    }
                  })
                "
                >За этот месяц</a
              >
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="20" :offset="0">
              <el-date-picker
                v-model="csvDateRange"
                type="datetimerange"
                align="right"
                start-placeholder="От"
                end-placeholder="До"
                :default-time="['00:00:00', '23:59:59']"
              >
              </el-date-picker>
            </el-col>
            <el-col :span="4" :offset="0">
              <el-button
                type="primary"
                icon="el-icon-download"
                @click="
                  getCsv(
                    csvDateRange
                      ? {
                          date: {
                            $lte: $dayjs(csvDateRange[1]),
                            $gte: $dayjs(csvDateRange[0])
                          }
                        }
                      : {}
                  )
                "
              ></el-button>
            </el-col>
          </el-row>
        </div>
        <el-button
          slot="reference"
          size="medium"
          :loading="csvLoading"
          style="float: right; margin: 3px 3px"
          icon="el-icon-download"
          >CSV</el-button
        >
      </el-popover>
      <!-- <div>
        <el-input
          v-model="query"
          placeholder="Поиск по архиву транзакций"
          size="normal"
          clearable
        ></el-input>
        <el-button type="primary" size="default" @click="onQuery"
          >Искать</el-button
        >
      </div> -->
    </div>

    <div class="content">
      <component
        :is="transactionComponent"
        :key="transaction._id"
        v-for="(transaction, index) in transactions"
        v-show="search.length ? transaction._id.indexOf(search) !== -1 : true"
        :transaction="transaction"
      >
        <div
          class="buttons"
          v-if="
            +transaction.status === 1 && !transaction.trans.wbWithdrawStatus
          "
        >
          <div style="display: flex;">
            <button
              type="button"
              class="ok"
              @click.prevent="submitTransaction(transaction._id, 2)"
            >
              Подтвердить
            </button>
            <button
              type="button"
              class="ok"
              @click.prevent="submitTransaction(transaction._id, 2, false)"
            >
              + без реферала
            </button>
          </div>

          <button
            type="button"
            class="cancel"
            @click.prevent="submitTransaction(transaction._id, 3)"
          >
            Отклонить
          </button>
        </div>

        <div class="buttons" v-if="+transaction.status === 6">
          <button
            type="button"
            class="ok"
            @click.prevent="verifyBankCard(transaction)"
          >
            Верифицировать
          </button>
          <button
            type="button"
            class="cancel"
            @click.prevent="submitTransaction(transaction._id, 3)"
          >
            Отклонить
          </button>
        </div>

        <div
          class="buttons"
          v-if="+transaction.status === 3 || +transaction.status === 4"
        >
          <button
            type="button"
            class="ok"
            @click.prevent="submitTransaction(transaction._id, 106)"
          >
            Возобновить
          </button>
        </div>
      </component>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import { saveVerifiedCard, queryTransactions, getTransactionsCsv } from "@/api";

import OrderTransaction from "../../ui/OrderTransaction.vue";
import OrderTransactionNew from "../../ui/OrderTransactionNew.vue";
import PageHeader from "../../ui/PageHeader.vue";
//
export default {
  components: { PageHeader },
  name: "Main",

  data: () => ({
    search: "",
    sort: "0",
    source: "",
    query: "",
    transactionComponents: [
      { component: OrderTransaction, title: "Классик", id: "classic" },
      { component: OrderTransactionNew, title: "Модерн", id: "modern" }
    ],
    selectedComponent: "classic",
    csvLoading: false,
    csvDateRange: null
  }),

  methods: {
    ...mapActions("transactions", [
      "getTransactions",
      "editTransaction",
      "deleteTransaction"
    ]),

    getStatusText(status) {
      switch (+status) {
        case 0:
          return "В ожидании средств";
        case 1:
          return "В обработке";
        case 2:
          return "Подтверждено";
        case 3:
          return "Отклонено";
        case 4:
          return "Отменено";
        case 5:
          return "В ожидании фото для верификации";
        case 6:
          return "Верификация";
        case 106:
          return "Возобновлен";
      }
    },

    getStatusCss(status) {
      switch (+status) {
        case 0:
        case 1:
          return { orange: true };
        case 2:
        case 106:
          return { green: true };
        case 3:
        case 4:
          return { red: true };
      }
    },

    async onQuery() {
      const queryBuilders = [
        {
          state: "query",
          builder: () => {
            const q = {
              $or: [
                {
                  ip: {
                    $regex: `.*${this["query"]}.*`,
                    $options: "i"
                  }
                }
                // {
                //   email: {
                //     $regex: `.*${this["query"]}.*`,
                //     $options: "i"
                //   }
                // }
              ]
            };
            if (this["query"].length === 12 || this["query"].length === 24)
              q["$or"].push({ _id: this["query"] });
            return q;
          }
        }
      ];
      try {
        const query = {
          $and: queryBuilders.map(b => b.builder())
        };
        const res = await queryTransactions({
          query
        });
        console.log(res);
      } catch (error) {
        console.log(error);
      }
    },

    removeTransaction(id) {
      alert("delete " + id);
      return this.deleteTransaction(id);
    },

    submitTransaction(_id, status, enableReferal = true) {
      const resultMessage = prompt("Сообщение для пользователя:");
      this.editTransaction({
        _id,
        status,
        resultMessage,
        enableReferal
      });
    },

    loadTransactionList() {
      return this.getTransactions({
        sort: this.sort,
        source: this.source
      }).then(() => this.$nextTick());
    },
    verifyBankCard(transaction) {
      let cardForm = transaction.give.forms.find(
        form =>
          form.key == "nomer_karti_s_kotoroi_otpravlyaete" ||
          form.key == "nomer_karti"
      );

      let cardNum = cardForm.value.replace(/\s*/gi, "");

      saveVerifiedCard(cardNum)
        .then(res => res.data)
        .then(data => console.log(data));

      this.submitTransaction(transaction._id, 0);
    },
    async getCsv(query = {}) {
      try {
        this.csvLoading = true;
        // const query = { dateStart: { $gte: "2022-11-22", $lte: "2022-11-31" } };
        const { data } = await getTransactionsCsv({
          pagination: false,
          query
        });
        const fileURL = window.URL.createObjectURL(new Blob([data]));
        const fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `exchanges_${this.$dayjs().format("DD_MM_YYYY_HH_mm_ss")}.csv`
        );
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        this.handleResponseError(error);
      } finally {
        this.csvLoading = false;
      }
    }
  },

  computed: {
    ...mapState("auth", ["session"]),
    ...mapState("transactions", ["transactions"]),
    transactionComponent() {
      return this.transactionComponents.find(
        c => c.id === this.selectedComponent
      )["component"];
    }
  },

  mounted() {
    this.loadTransactionList();
  }
};
</script>

<style scoped>
.content {
  overflow: hidden;
}

.buttons {
  margin-top: 10px;
  display: inline-block;
  width: 100%;
}

.buttons > button {
  width: 49%;
  display: inline-block;
  cursor: pointer;
}

.buttons > button.ok {
  background-color: green;
  color: #ffffff;
}

.buttons > button.cancel {
  background-color: red;
  color: #ffffff;
}

.sub_header {
  margin-top: 60px;
}

#app > .page > .content {
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Transactions/index.vue